export const ONLINE = "online";
export const RETURN_TOPIC = "return-topic";
export const RETURN_HISTORY = "return-history";
export const LIVE_DATA = "live-data";
export const GET_HISITORY = "get-history";
export const DELETE_SINGLE_DATA_BY_ID = "delete-single-data-by-id";
